import React from 'react';
import { Layout } from '../../../components';

const HelpCenter = () => {
    return (
        <Layout title='Pusat Bantuan' showNavBar={true} showNavigation={false}>

        </Layout>
    );
};

export default HelpCenter;